//example taken from https://codepen.io/SitePoint/pen/KMYMXr?editors=0010
// EXAMPLES
//
// // Default 5 min
// cachedFetch('https://httpbin.org/get')
// .then(r => r.json())
// .then(info => {
//   console.log('Your origin is ' + info.origin)
// })

// // 2 minutes
// cachedFetch('http://httpbin.org/gzip', 2 * 60)
// .then(r => r.json())
// .then(info => {
//   console.log('Your origin (with gzip) is ' + info.origin)
// })

// // 1 minute
// cachedFetch('http://httpbin.org/ip', { seconds: 60 })
// .then(r => r.json())
// .then(info => {
//   console.log('Your origin (by ip only) is ' + info.origin)
// })


export interface CachedFetchRequestOptions {
  seconds?: number;
  request?: RequestInit;
  cacheBuster?: boolean;
}

const DEFAULTS: CachedFetchRequestOptions = {
  seconds: 5 * 60,
  request: {
    credentials: 'include'
  },
  cacheBuster: false
};

const cacheBuster = (): number => new Date().getTime();

export default function (url: string, options: CachedFetchRequestOptions = {}): Promise<Response> {
  const mergedOptions: CachedFetchRequestOptions = { ...DEFAULTS, ...options };
  const requestUrl = url;
  const cachedRequest = sessionStorage.getItem(requestUrl);
  const whenCachedRequest = parseInt(sessionStorage.getItem(requestUrl + ':ts') || '0', 10);

  if (cachedRequest !== null && whenCachedRequest !== 0) {
    const age = (Date.now() - whenCachedRequest) / 1000;
    if (age < mergedOptions.seconds! && !mergedOptions.cacheBuster) {
      const response = new Response(new Blob([cachedRequest]));
      return Promise.resolve(response);
    } else {
      sessionStorage.removeItem(requestUrl);
      sessionStorage.removeItem(requestUrl + ':ts');
    }
  }

  return fetch(url, mergedOptions.request!).then(async (response) => {
    if (response.status === 200) {
      const ct = response.headers.get('Content-Type');
      if (ct && (ct.match(/application\/json/i) || ct.match(/text\//i))) {
        await response
          .clone()
          .text()
          .then((content) => {
            sessionStorage.setItem(requestUrl, content);
            sessionStorage.setItem(requestUrl + ':ts', Date.now().toString());
          });
      }
    }
    return response;
  });
}
